import TippyToolTip from "@tippy.js/react"
import "tippy.js/dist/tippy.css"
export const ToolTip = TippyToolTip
